import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { MAX_MOBILE_WIDTH_IN_PX } from '../constants';
import useHasReactRouterContext from '../../../hooks/useHasReactRouterContext';
import { GreetingBubble, HEIGHT_TRIANGLE_IN_REM } from './GreetingBubble';
import { Avatar, DIAMETER_AVATAR_IN_REM_DESKTOP } from './Avatar';
const HEIGHT_CIRCLE_SHADOW_IN_REM = 0.25;
const DISTANCE_AVATAR_BUBBLE_IN_REM = 0.5;
const LinkWrapper = styled.a `
  align-self: start;
  height: ${DIAMETER_AVATAR_IN_REM_DESKTOP}rem;
  position: relative;
  top: 0.5rem;
  text-decoration: none;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH_IN_PX}px) {
    height: auto;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
  }

  &.focus-visible {
    outline: none;

    &::before {
      border-radius: 50%;
      box-shadow: 0 0 0.3125rem 0
        ${props => props.theme.colors['1-color-6-shades-of-secondary-shaded-blue']};
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      z-index: 201;
    }
  }
`;
const GreetingBubbleWrapper = styled.span `
  pointer-events: none;
  position: absolute;
  right: 0;
  top: ${HEIGHT_TRIANGLE_IN_REM +
    DIAMETER_AVATAR_IN_REM_DESKTOP +
    HEIGHT_CIRCLE_SHADOW_IN_REM +
    DISTANCE_AVATAR_BUBBLE_IN_REM}rem;
`;
export const AvatarHeaderBar = ({ alt, showName, src, to, 'data-trackingid': dataTrackingId, 'data-testid': dataTestId, onClick = undefined, }) => {
    const hasReactRouterContext = useHasReactRouterContext();
    function renderComponent() {
        return (React.createElement(React.Fragment, null,
            React.createElement(Avatar, { alt: alt, src: src }),
            Boolean(showName) && (React.createElement(GreetingBubbleWrapper, null,
                React.createElement(GreetingBubble, null, showName)))));
    }
    if (hasReactRouterContext) {
        return (React.createElement(LinkWrapper, { as: Link, to: to, "data-trackingid": dataTrackingId, "data-testid": dataTestId, onClick: onClick }, renderComponent()));
    }
    else {
        return (React.createElement(LinkWrapper, { "data-trackingid": dataTrackingId, "data-testid": dataTestId, href: to, onClick: onClick }, renderComponent()));
    }
};
